"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _excluded = ["srcPictureOne", "srcPictureTwo", "srcPictureThree", "altPictureOne", "altPictureTwo", "altPictureThree"],
  _excluded2 = ["whatWeDoPictureOne", "whatWeDoPictureTwo", "whatWeDoPictureThree", "whatWeDoAltPictureOne", "whatWeDoAltPictureTwo", "whatWeDoAltPictureThree"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var WhatWeDoImage = _styledComponents.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  padding-bottom: 16.5px; \n  padding-top: 16.5px;\n\n  @media (min-width: ", ") {\n  }\n\n  @media (min-width: ", ") {\n    width: 100%;\n    padding-bottom: 32.5px; \n    padding-top: 32.5px;\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    gray: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionParagraph = (0, _styledComponents.default)(function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children;
  return _react.default.createElement(_Paragraph.default, {
    gray: true,
    className: className
  }, " ", children, " ");
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledColumn = (0, _styledComponents.default)(_Grid.default)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  margin-bottom: 20px;\n"])));
function WhatWeDoThreeColumn(_ref4) {
  var srcPictureOne = _ref4.srcPictureOne,
    srcPictureTwo = _ref4.srcPictureTwo,
    srcPictureThree = _ref4.srcPictureThree,
    altPictureOne = _ref4.altPictureOne,
    altPictureTwo = _ref4.altPictureTwo,
    altPictureThree = _ref4.altPictureThree,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  return _react.default.createElement(_ThreeColumnLayout.default, Object.assign({
    justifyContent: 'center'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(WhatWeDoImage, {
    src: srcPictureOne,
    alt: altPictureOne
  })), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(WhatWeDoImage, {
    src: srcPictureTwo,
    alt: altPictureTwo
  })), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(WhatWeDoImage, {
    src: srcPictureThree,
    alt: altPictureThree
  })));
}
;
var WhatWeDo = function WhatWeDo(_ref5) {
  var whatWeDoPictureOne = _ref5.whatWeDoPictureOne,
    whatWeDoPictureTwo = _ref5.whatWeDoPictureTwo,
    whatWeDoPictureThree = _ref5.whatWeDoPictureThree,
    whatWeDoAltPictureOne = _ref5.whatWeDoAltPictureOne,
    whatWeDoAltPictureTwo = _ref5.whatWeDoAltPictureTwo,
    whatWeDoAltPictureThree = _ref5.whatWeDoAltPictureThree,
    props = (0, _objectWithoutProperties2.default)(_ref5, _excluded2);
  return _react.default.createElement(_PageGrid.default, Object.assign({
    heroBackgroundColor: 'var(--bf-light-gray)'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center",
    justifyContent: "center"
  }, props), _react.default.createElement(StyledColumn, {
    item: true,
    justifyContent: "center"
  }, _react.default.createElement(StyledSectionHeading, {
    h1: true,
    teal: true
  }, " ", props.headingCopy, " "), props.subheadingCopy ? _react.default.createElement(StyledSectionSubheading, {
    hsub: true,
    special: true
  }, " ", props.subheadingCopy, " ") : _react.default.createElement(_react.default.Fragment, null), props.bodyCopy ? _react.default.createElement(StyledSectionParagraph, null, " ", props.bodyCopy, " ") : _react.default.createElement(_react.default.Fragment, null)), _react.default.createElement(WhatWeDoThreeColumn, Object.assign({
    srcPictureOne: whatWeDoPictureOne,
    srcPictureTwo: whatWeDoPictureTwo,
    srcPictureThree: whatWeDoPictureThree,
    altPictureOne: whatWeDoAltPictureOne,
    altPictureTwo: whatWeDoAltPictureTwo,
    altPictureThree: whatWeDoAltPictureThree
  }, props))));
};
var _default = WhatWeDo;
exports.default = _default;